import React from 'react';
import { Button } from '@hometap/htco-components';

const ClaimButton = ({ onClick, testId }) => (
  <Button theme="text" className="ClaimButton" label="Claim" data-testid={testId} onClick={onClick} />
);

export default ClaimButton;
